// map recursive
export function isUndefined(obj: any): obj is undefined {
    return typeof obj === 'undefined';
}

export function mapRecursive(fn: (e: any, parent: any, index?: number) => any, parent: any, arr: any[]): any[] {
    const result: any[] = [];
    for (let i = 0; i < arr.length; i++) {
        const el = fn(arr[i], parent);
        if (Array.isArray(el)) {
            result.push(...el);
        } else {
            result.push(el);
        }
    }
    return result;
}

export function foreachRecursive (fn: (e: any, el_to_find: any, index?: number) => any, el_to_find: any, [first, ...rest]: any[], index?: number) {
    if (!isUndefined(first)) {
        fn(first, el_to_find, index);
        foreachRecursive(fn, el_to_find, rest, index !== undefined ? index+1 : undefined);
    }
}

export function findRecursive(fn: (e: any, el_to_find: any, index?: number) => any, el_to_find: any, [first, ...rest]: any[]): any | undefined {
    return isUndefined(first) ? undefined : (fn(first, el_to_find) || findRecursive(fn, el_to_find, rest));
}

export function arrayEquals(a: any[], b: any[]) {
    return Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => val == b[index]);
}

export function trimEllip(val: string, length: number): string {
    return val.length > length ? val.substring(0, length) + "..." : val;
}

export function trimEllipHtml(html: string, max: number): string {
  if (html.length <= max) return html
  const truncated = html.slice(0, max)
  const lastTag = truncated.lastIndexOf('<')
  const lastClose = truncated.lastIndexOf('>')
  if (lastTag > lastClose) {
    return truncated.slice(0, lastClose + 1) + '...'
  }
  return truncated + '...'
}
